// project imports
import {
  AssignInspectionDTO,
  InspectionDTO,
  SiteDTO,
} from "../../../common/types/common.dto.types";
import { ActionResponseType } from "../../../common/types/common.types";
import { ApiClient } from "../../../core/api/apiClient.service";
import { AxiosError } from "axios";
// client object for axios calls to backend
const client = new ApiClient();

/* ==============================|| VIEWS - PAGES - ASSIGN INSPECTION - API ||==============================  */

export const getInspectionData = async (
  inspection: InspectionDTO
): Promise<SiteDTO> => {
  try {
    const URL: string = `AssignInspection/GetInspectionData`;
    let result = {} as SiteDTO;
    await client
      .post<ActionResponseType>(URL, inspection)
      .then((response: ActionResponseType) => {
        result = response.Data;
      })
      .catch((error) => {
        // console.log(error);
      });
    return result;
  } catch (error) {
    throw error;
  }
};

export const saveAssignInspection = async (
  site: AssignInspectionDTO
): Promise<ActionResponseType> => {
  try {
    let URL: string = "AssignInspection/UpdateInspectionData";

    let result: ActionResponseType = {} as ActionResponseType;
    await client
      .post<ActionResponseType>(URL, site)
      .then((response) => {
        result = response;
      })
      .catch((error: AxiosError) => {
        return error;
      });
    return result;
  } catch (error) {
    throw error;
  }
};

export const getInspectionStandardList = async (
  inspection: InspectionDTO
): Promise<SiteDTO> => {
  try {
    const URL: string = `AssignInspection/GetInspectionStandardList`;
    let result = {} as SiteDTO;
    await client
      .post<ActionResponseType>(URL, inspection)
      .then((response: ActionResponseType) => {
        result = response.Data;
      })
      .catch((error) => {
        // console.log(error);
      });
    return result;
  } catch (error) {
    throw error;
  }
};
